export type AbaId = 'periodo-anterior' | 'periodo-novo';

interface ConfigAbas {
  abaInicial: AbaId;
  rotulos: (data: any, dataPeriodoNovo: any) => { anterior: string; novo: string };
}

const totalRespostas = (d: any): number | undefined => {
  const total = d?.respostas?.total ?? d?.respostas;
  return typeof total === 'number' ? total : undefined;
};

// Período ainda não preenchido no dado ("XX/XX a XX/XX/20XX") não vai pro rótulo
const periodoValido = (periodo?: string): string | undefined =>
  periodo && !/XX/i.test(periodo) ? periodo : undefined;

const rotuloEstudo = (nome: string, d: any): string => {
  const detalhes = [
    totalRespostas(d) != null ? `${totalRespostas(d)} respostas` : undefined,
    periodoValido(d?.periodo),
  ].filter(Boolean);
  return detalhes.length ? `${nome} (${detalhes.join(' · ')})` : nome;
};

// Operadoras com duas abas. CELOS e PAS/SERPRO não tiveram diagnóstico anterior → visão única.
const configPorOperadora: Record<string, ConfigAbas> = {
  fups: {
    abaInicial: 'periodo-anterior',
    rotulos: () => ({
      anterior: 'Período Anterior (23/04 a 06/05/2025)',
      novo: 'Período Novo (23/04 a 01/06/2025)',
    }),
  },
  'plas-jmu': {
    abaInicial: 'periodo-novo',
    rotulos: (data, novo) => ({
      anterior: `Período Anterior (${data.periodo})`,
      novo: `DX — Atualização (${novo?.periodo ?? ''})`,
    }),
  },
  elosaude: {
    abaInicial: 'periodo-anterior',
    rotulos: (data, novo) => ({
      anterior: rotuloEstudo('Estudo geral Elosaúde', data),
      novo: rotuloEstudo('Estudo PAMPA', novo),
    }),
  },
};

export const temAbasPeriodo = (operadoraId: string, dataPeriodoNovo: unknown): boolean =>
  operadoraId in configPorOperadora && !!dataPeriodoNovo;

export const abaInicial = (operadoraId: string): AbaId =>
  configPorOperadora[operadoraId]?.abaInicial ?? 'periodo-anterior';

export const rotulosAbas = (operadoraId: string, data: any, dataPeriodoNovo: any) =>
  configPorOperadora[operadoraId]?.rotulos(data, dataPeriodoNovo) ?? { anterior: '', novo: '' };
